import MarkerMapBaloon from './MapMarkerBaloon';

function MapObjectBaloonManager(model, mapView) {
  this.model = model;
  this.infoBaloonOverlay = null;
  this.objectId = null;
  this.mapView = mapView;
  this.mapObject = this.mapView.map;
  this.model.addListener(this);
}

MapObjectBaloonManager.prototype = {
  hide() {
    if (this.infoBaloonOverlay !== null) {
      this.infoBaloonOverlay.setMap(null);
      this.infoBaloonOverlay = null;
      this.objectId = null;
    }
  },

  show(objectId) {
    if (objectId !== this.objectId) {
      this.hide();
      this.model
        .getMarkerHtml(objectId)
        .then(data => {
          this.infoBaloonOverlay = new MarkerMapBaloon(
            objectId,
            this.mapView.getMarker(objectId).marker,
            data.html,
            this.mapView,
            this,
          );
          this.objectId = objectId;
          this.infoBaloonOverlay.setMap(this.mapObject);
        })
        .catch(error => {
          console.error(error);
        });
    }
  },

  onSelect(eventObj) {
    this.show(eventObj.new);
  },

  getBaloonHtml() {
    const markerData = this.model.getMarkerData();
    let html =
      '<div class="balloon-content"><p class="title">' +
      markerData['name'] +
      '</p>';
    if (markerData['start_time'] !== null && markerData['end_time'] !== null) {
      html +=
        '<p class="event-date">' +
        markerData['start_time'] +
        ' - ' +
        markerData['end_time'] +
        '</p>';
    }
    if (markerData['link'] !== null) {
      html +=
        '<a class="more-info" href="' +
        markerData['link'] +
        '">Više informacija</a>';
    }
    html += '</div>';
    return html;
  },

  onUnselect() {
    this.hide();
  },
};

export default MapObjectBaloonManager;



// WEBPACK FOOTER //
// ./src/js/maps/MapObjectBaloonManager.js